import React, { Component } from 'react'
import { connect } from 'react-redux';
import { gameActions } from '../action/GameAction'
import Barcode from 'react-barcode';
import { withTranslation } from 'react-i18next';
import { alertActions } from '../../component/action/AlertAction';
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import ReactToPrint from "react-to-print";
import { commonClass } from '../helpers/commonClass';
class BetSlip extends Component {
    constructor(props) {
        super(props);
        this.state = { counter: 1 }
    }

    PrintBetSlip = (id) => {
        window.PrintBetSlip(id);
        return;
    };
    downloadPdfDocument = (downloadFileName) => {
        let downID = "qwinprint1";
        let downDivID = "qwinprint";
        document.getElementById(downID).style.maxHeight = "none"
        let input = document.getElementById(downDivID);
        html2canvas(input)
            .then((canvas) => {
                let imgData = canvas.toDataURL('image/png');
                //let pdf = new jsPDF();
                //pdf.addImage(imgData, 'JPEG', 20, 0);
                let pdf = new jsPDF("p", "mm", "a4");
                var width = pdf.internal.pageSize.getWidth();
                var height = (pdf.internal.pageSize.getHeight() - 10);
                pdf.addImage(imgData, 'JPEG', 3, 3, 140, input.offsetHeight * 0.4);
                // pdf.addImage(imgData, 'JPEG', 3, 3, width, input.offsetHeight*0.6);
                pdf.save(`${downloadFileName}.pdf`);
            })
        document.getElementById(downID).style.removeProperty("max-height")
    }

    getPrintCont = () => {
        let downID = "qwinprint1";
        let downDivID = "qwinprint";
        document.getElementById(downID).style.maxHeight = "none"
        let input = document.getElementById(downDivID).cloneNode(true);
        document.getElementById(downID).style.removeProperty("max-height");
        input.style.marginTop = '30px'
        return input;
    }

    componentDidMount() {
        if (this.props.alertReducer.message) {
            setTimeout(() => {
                if (window.MessageBox) {
                    window.MessageBox()
                }
            }, 500);
        }
    }
    CloseMsgBox = () => {
        if (window.ClosePopup) {
            setTimeout(() => {
                window.ClosePopup()
            }, 100);
        }
    }
    render() {
        const { alertReducer } = this.props;
        const { t } = this.props;
        let flst = [];
        let _transID = "";
        let _gameID = "";
        let _gameTime = "";
        function dd(Id, GameTime, GameID) {
            _transID = Id;
            _gameTime = GameTime;
            _gameID = GameID;
        }
        function tfilte(betLst) {
            flst = [...new Set(betLst.map(item => item.GameID))]
        }
        return (
            <>
                {this.props.myReBet && this.props.myReBet.status == 0 && <>
                    <div className="ticketBox" style={{ transform: "translate(-50%, -50%)", display: "block" }}>
                        <div className="ticketBoxWrap">
                            <a className="lightBoxClose" onClick={() => { this.props.closeBetSlip() }}><img src="./assets/img/icons/pop_close.png" alt='close icon' /></a>
                            <div className="table margin-top-20" id='qwinprint'>
                                <ul class="transTble">
                                    <li>
                                        <div class="w-10 text-center">Sr. No</div>
                                        <div class="w-40 text-left"> {t('lblTicket')}</div>
                                        <div class="w-25">{t('lblSubmitted')}</div>
                                        <div class="w-20">{t('lblModeOfPay')}</div>
                                    </li>
                                    {dd(this.props.myReBet.betLst[0].Id, this.props.myReBet.betLst[0].GameTime, this.props.myReBet.betLst[0].GameID)}
                                    {tfilte(this.props.myReBet.betLst)}
                                    {flst.map((x1, idx1) => <>
                                        {this.props.myReBet.betLst.filter(a => a.GameID == x1).map((x, idx) =>
                                            <li>
                                                <div class="w-10 text-center">{idx + 1}</div>
                                                <div class="w-40">
                                                    <div class="ticketInfoBall">
                                                        {x.BallNo.split(';').map((x2, idx2) => <div key={`s_${idx2}`} className={`lottoInfoBall lto-${x.gamegroupID}-border lto-${x.gamegroupID}-active`} > {x2}</div>)}
                                                    </div>
                                                </div>
                                                <div class="w-25">{this.props.myReBet.betLst[0].TransDateTime}</div>
                                                <div class="w-25">{this.props.myReBet.payment_mode}</div>
                                            </li>
                                        )}
                                    </>
                                    )}
                                </ul>
                                {/* {dd(this.props.myReBet.betLst[0].Id, this.props.myReBet.betLst[0].GameTime, this.props.myReBet.betLst[0].GameID)} */}
                                {/* <div className="newTicketInner ticketSlipInner no-scrollbar" id='qwinprint1'>
                                    <div className='ticketLogo'><img src="./assets/img/logo.webp" alt='Gulf logo icon' /></div>
                                    <div className='dateAndTime1 gameTicketDetails'>
                                        <h1>{t('lblTicketDet')}</h1>
                                        <span className="time">{t('lblTransId')}: {_transID}</span>
                                        <span className="time !pt-0">{t('lblDrawDate')}: {this.props.myReBet.betLst[0].GameTime}</span>
                                    </div>

                                    {tfilte(this.props.myReBet.betLst)}
                                    {flst.map((x1, idx1) => <>
                                        {this.props.myReBet.betLst.filter(a => a.GameID == x1).map((x, idx) =>
                                            <div className="ticketsContainer !px-4" key={`r_${idx1}`}>
                                                <section className={`purchasedTicketContainer ticket-cut-game-${x.gamegroupID} topTicketMargin bg-game${x.gamegroupID}`}>
                                                    <div className="ticketsAlign">
                                                        <span className="purchaseTicketHead">{x.GameName}</span>
                                                        <div className="ticketNumber">{t('lblTicket')} #{idx + 1}</div>
                                                        {x.gamegroupID == 13 && <div className="raffleId">{t('lblentryamt')}: {x.StakeValue}</div>
                                                        }
                                                    </div>
                                                    {x.gamegroupID == 13 ?
                                                        <div>
                                                            <div className={`lckmyCartBallTkt game-13-balls-${parseInt(x.BallNo)}`}></div>
                                                            <span className="lckTktNo">{parseInt(x.BallNo)}</span>
                                                        </div>
                                                        : <div>
                                                            <div className="selectedNumbers">
                                                                {x.BallNo.split(';').map((x2, idx2) => <span key={`s_${idx2}`} className="individualNumber" > {x2}</span>)}
                                                                {x.gamegroupID == 15 && x.Pick3BetTypeName && x.Pick3BetTypeName.length > 0 && <div className="gameTypeBtn gameTypeBtn2 gameTypeBtnPayment border-left-0"><a className="bg-white margin-0-auto">{x.Pick3BetTypeName}</a></div>}
                                                            </div>
                                                            {x.gamegroupID == 15 ? <></> : <div className="raffleId text-center">{t('lblRafflaID')}: {x.RaffleID}</div>}
                                                        </div>
                                                    }
                                                </section>
                                            </div>
                                        )}
                                        <section className="px-4 pt-2" >
                                            <p className="ticketSlipcontent">
                                                <span>{t('lblPlays')}</span>
                                                <span>{this.props.myReBet.betLst.length}</span>
                                            </p>
                                            <p className="ticketSlipcontent">
                                                <span>{t('lblStatus')}</span>
                                                <span>{this.props.myReBet.ticketStatus}</span>
                                            </p>
                                            <p className="ticketSlipcontent">
                                                <span>{t('lblSubmitted')}</span>
                                                <span>{this.props.myReBet.betLst[0].TransDateTime}</span>
                                            </p>
                                            <p className="ticketSlipcontent">
                                                <span>{t('lblTicketId')}</span>
                                                <span>{_transID}</span>
                                            </p>
                                            <p className="ticketSlipcontent">
                                                <span>{t('lblTotalSpend')}</span>
                                                <span>{process.env.REACT_APP_CURRENCY} {this.props.myReBet.betLst.reduce((a, b) => a = a + b.StakeValue, 0)}</span>
                                            </p>
                                            {this.props.myReBet.payment_mode != "" &&
                                                <p className="ticketSlipcontent">
                                                    <span>{t('lblModeOfPay')}</span>
                                                    <span>{this.props.myReBet.payment_mode}</span>
                                                </p>}

                                            {this.props.myReBet.Promotionid && this.props.myReBet.Promotionid.length > 0 && <p className="ticketSlipcontent">
                                                <span>Promotion ID</span>
                                                <span>{this.props.myReBet.Promotionid}</span>
                                            </p>}
                                            {this.props.myReBet.winamt != 0 &&
                                                <p className="ticketSlipcontent">
                                                    <span>{t('lblWinnings')}</span>
                                                    <span>{process.env.REACT_APP_CURRENCY} {this.props.myReBet.winamt}</span>
                                                </p>}
                                        </section>
                                        <div className="dateAndTime1" style={{ "width": "0%" }}>
                                            <div className="barCode">
                                                <Barcode displayValue="true" height="50px" format="CODE128" value={_transID} />
                                            </div>
                                        </div>
                                        {this.props.myReBet.buttomMsg && this.props.myReBet.buttomMsg != "" &&
                                            <span className="copyrgtTicket">{this.props.myReBet.buttomMsg}</span>
                                        }
                                    </>
                                    )}
                                </div> */}
                            </div>
                            {/* <div className="DownLoadBtn">
                                <a onClick={() => { this.downloadPdfDocument(_transID) }}><img src="./assets/img/icons/inbox_download.webp" alt='inbox_download icon' /></a>
                                <ReactToPrint
                                    trigger={() => <a><img src="./assets/img/icons/printer.webp" alt='printer icon' /></a>}
                                    content={() => this.getPrintCont()}
                                />
                            </div> */}
                        </div>
                    </div>
                    <div className="overlayLogin" style={{ display: "block" }}></div>
                </>}
                {
                    this.props.myReBet && this.props.myReBet.status != 0 && <>
                        <div className="lightbox2" style={{ transform: "translate(-50%, -50%)", backgroundColor: 'transparent', display: "block" }}>
                            <div className="newCo">
                                <div className="newCoInner">
                                    {/* <div className="newCoInnerLft">
                                        <img src="./assets/img/icons/Betslip.png" />
                                        <span>{t('lblgameslip')}</span>
                                    </div> */}
                                    <div className="newCoInnerRgt" onClick={() => { this.props.closeBetSlip() }}>
                                        <i className="fa fa-times" aria-hidden="true"></i>
                                    </div>
                                </div>
                                <div className="newCoWrap">
                                    <div className="betSec">
                                        <div className="betValCont">
                                            <div className="playAmount">
                                                <span className="plyAmntTxt" style={{ textAlign: "center", width: "100%", fontSize: "16px", fontFamily: "'helvetica-condensed-bold'" }}>{this.props.myReBet.msg}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="overlaybetsilp" style={{ display: "block" }}></div>
                    </>
                }
                {
                    alertReducer.loading &&
                    // <div id="loadingOverlay">
                    //     <div id="loader">
                    //         <div className="lds-dual-ring"><div></div><div></div></div>
                    //     </div>
                    // </div>
                    <div id="loadingOverlay">
                        <div class="loaderCont">
                            <p>Leveling up the fun… Just a few more seconds!</p>
                            <div class="loader">
                                <div class='progress-bar'>
                                    <div class='prog-status'></div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {
                    alertReducer.message && <>
                        <div className="messageBox" style={{ transform: "translate(-50%, -50%)", display: "block" }}>
                            <div className="messageBoxWrap" style={{ borderColor: alertReducer.alertcolor }}>
                                <p>{alertReducer.message}</p>
                                <div>
                                    <button onClick={() => { this.props.clearAlerts(alertReducer.loginFlag) }}>{t('lblOk')}</button>
                                </div>
                                {/* <div className="userContent">
                                    <h2 style={{ color: alertReducer.alertcolor, textAlign: "center", padding: "20px", fontSize: "16px" }}>{alertReducer.message}</h2>
                                    <div className="altBtns">
                                        <button className="bg3" style={{ backgroundColor: alertReducer.alertcolor, fontSize: "16px" }} onClick={() => { this.props.clearAlerts(alertReducer.loginFlag) }}>{t('lblOk')}</button>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <div style={{ display: "block" }} className="overlayMessage"></div>
                    </>

                }
                {
                    alertReducer.WinInfo && <>
                        <div id="winnerWrap">
                            <div class="winningOverlay"></div>
                            <div class="particle-wrap" id="particleWrap"></div>
                            <div className="messageBox" style={{ transform: "translate(-50%, -50%)", display: "block" }} >
                                <div class="winningBoxWrap">
                                    <a onClick={() => this.CloseMsgBox()} class="lightBoxClose"><img src="./assets/img/icons/pop_close.png" /></a>
                                    {this.props.WinAmnt && this.props.WinAmnt.split("~")[0] && <div>
                                        <img src="./assets/img/roulette/winning.png" />
                                    </div>}
                                    <div><p>{t('lblWinAmnt')}</p></div>
                                    {this.props.WinAmnt && this.props.WinAmnt.split("~")[0]?<h3>{process.env.REACT_APP_CURRENCY_NAME} {this.props.WinAmnt && this.props.WinAmnt.split("~")[0]}</h3>:<h3>{this.props.WinAmnt && this.props.WinAmnt.split("~")[1]}</h3>}
                                </div>
                            </div>
                        </div>
                        <div style={{ display: "block" }} className="overlayMessage"></div>

                    </>

                }
            </>
        )
    };
}

function mapStateToProps(state) {
    const { myReBet, WinAmnt } = state.gameReducer;
    const { appvariables } = state.loginReducer;
    const { alertReducer } = state;
    return { myReBet, appvariables, alertReducer, WinAmnt };
}
const mapActionToProps = {
    closeBetSlip: gameActions.closeBetSlip,
    loading: alertActions.loading,
    clearAlerts: alertActions.clear,
}

export default connect(mapStateToProps, mapActionToProps)(withTranslation()(BetSlip))